exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".open-map-label {\n  position: absolute;\n  background: white;\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content;\n  padding: 2px 4px 0px 4px;\n  top: -17px;\n  border-radius: 5px;\n  font-weight: 600; }\n\n.history-play {\n  z-index: 1;\n  bottom: 122px;\n  position: absolute;\n  background: white;\n  padding: 10px;\n  /* box-shadow: 3px 2px 5px 0px rgb(178 176 174); */\n  left: 15px;\n  width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/open-map/open-map.component.scss
// module id = ../../../../../src/app/open-map/open-map.component.scss
// module chunks = main